import React from "react";

const SkeletonCard = () => (
  <div className="aok-card aok-skeleton-card">
    <div className="aok-card-row">
      <div className="aok-card-left">
        <div className="aok-skeleton-block aok-skeleton-avatar" />
        <div className="aok-info">
          <div className="aok-skeleton-block aok-skeleton-name" />
          <div className="aok-skeleton-block aok-skeleton-ceo" />
          <div className="aok-progress-row">
            <div className="aok-skeleton-block aok-skeleton-progress" />
            <div className="aok-skeleton-block aok-skeleton-status" />
          </div>
        </div>
      </div>
      <div className="aok-card-actions">
        <div className="aok-skeleton-block aok-skeleton-btn" />
      </div>
    </div>
  </div>
);

// Loading placeholder for the client list. Mirrors the real card layout rather
// than a spinner or a "Loading…" line, per CLAUDE.md — the same standard
// `ExecutionBlueprintSkeleton` and `StrategyCanvasSkeleton` set.
const AnnualOkrSkeleton = ({ count = 5 }) => (
  <div className="aok-list">
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonCard key={index} />
    ))}
  </div>
);

export default AnnualOkrSkeleton;
